<template>
  <div class="ace-footnote">
    <h3 class="ace-footnote__title">About the Adesco Carbon Estimator (ACE)</h3>
    <div class="ace-footnote__body">
      <p>
        The Adesco Carbon Estimator is the first calculator in the world to combine independently
        verified models with real world data from Irish Grain, drawn from over a period of 2 years.
        The estimator should be used as a guideline only, as with all natural materials, variances
        will occur. A more detailed analysis of specific materials or processes is available on
        request.
      </p>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
.ace-footnote {
  margin: 60px auto 0;
  max-width: 680px;
  &__title {
    font-size: 15px;
    line-height: 18px;
  }
  &__body {
    p {
      font-weight: 300;
    }
  }
}
</style>
